module.exports = __webpack_public_path__ + "static/media/SF-15-A (1).9e11c535.mp3";